let chart = {
  option : {
    title : {
        show: false,            
        x:'center'
    },
    tooltip : {
        trigger: 'item',
        formatter: "{b} : {c} ({d}%)"
    },
    legend: {
        show:false,
        orient: 'vertical',            
        x: 'left',
        data: ['Jokowi-Amin','Prabowo-Sandi']
    },
    toolbox: {
        show : false,
        x: 'right',
        feature : {
            mark : {show: true},
            //dataView : {show: true, readOnly: false},
            //restore : {show: true},
            saveAsImage : {show: true, title:'Pict'}
        }
    },
    series : [
        {
            name: 'pilpres',
            type: 'pie',
            radius : '80%',
            center: ['50%', '50%'],
            data:[
                               
            ],
            itemStyle : {
                normal : {
                    label : {
                        position : 'inner',
                        formatter : "{d}%"
                        /*formatter : function (params) {                         
                          return (params.percent - 0).toFixed(0) + '%'
                        }*/
                    },
                    labelLine : {
                        show : true
                    }
                },
                /*emphasis : {
                    label : {
                        show : true,
                        formatter : "{d}%"
                    }
                }*/

            },
        }
    ]
  }   
}; 

export default chart;

